import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div<{ border?: boolean }>`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 10px;
    align-items: center;

    ${({ border }) => {
        if (border) {
            return `
				padding: 15px;
				border: 1px solid rgba(128, 128, 128, 1);
				border-radius: 5px;
			`;
        }

        return `
			padding-bottom: 10px;
		`;
    }}
`;

interface FormWrapperProps {
    className?: string;
    border?: boolean;
}

const FormWrapper: React.FC<FormWrapperProps> = ({ children, border = true, className = 'widgetConfigurator' }) => (
    <StyledDiv className={className} border={border}>
        {children}
    </StyledDiv>
);

export default FormWrapper;
